const styles = (theme) => ({
  formContainer: {
    overflow: "hidden",
    padding: "0px 24px 24px 24px",
    flexGrow: 1,
  },
  defaultInput: {
    width: "100%",
    margin: 0,
  },
  divider: {
    backgroundColor: theme.gridIconBorderColor,
    opacity: 0.6,
    marginTop: 16,
  },
  inputRowContainer: {
    display: "flex",
    alignItems: "center",
    marginTop: 16,
  },
  rowLabel: {
    minWidth: "30%",
    fontSize: 12,
    color: theme.dispatchPanelHeaderColor,
  },
  dateTimeEditor: {
    width: 100,
  },
  terminalContainer: {
    marginBottom: 12,
  },
  labelStyle: {
    color: theme.HeaderSelectedText,
    fontSize: 14,
    fontWeight: 600,
    minWidth: "20%",
  },
  shipperInfoFormWrapper: {
    padding: 16,
    paddingTop: 4,
    border: `1px solid ${theme.AppBGColor}`,
    borderRadius: "4px",
  },
  account: {
    margin: 0,
    width: "96%",
  },
  accountContainer:{
    display : "flex",
    alignItems : "center",
    width: "100%",
    justifyContent: "flex-start"
  },
  accountFieldContainer:{
    width: "80%",
  },
  accountLabelClass:{
    minWidth : "38%"
  },
  shipperIcon:{
   color:theme.iconColor,
   height: 20,
   width: 20,
   cursor: "pointer"
  },
  shipperIconDisabled:{
    opacity: 0.7,    
    color:theme.iconColor,
    height: 20,
    width: 20,
    cursor: "not-allowed"
   },
  contact: {
    margin: 0,
    width: "70%",
  },
  terminal: {
    margin: 0,
    width: "40%",
  },
  searchButton: {
    fontSize: theme.textFontSize,
    flexGrow: 1,
    borderRadius: "unset",
  },
  activeSelection: {
    color: theme.white,
    backgroundColor: theme.HeaderSelectedText,
    "&:hover": {
      backgroundColor: theme.HeaderSelectedText,
    },
  },
  readOnlyValue: {
    fontSize: theme.textFontSize,
    color: theme.gridTextColor,
  },
  error : {
    color : theme.error
  }
});

export default styles;
